
  <mat-tab-group>
    <mat-tab label="Sobre">
      <div class="organizationInformations">
        <b>Nome:</b> {{ this.location.alias[0] }} <br />
        <b>Representante legal:</b> {{ this.location.managingOrganization.legal_representative }} <br />
        <b>CNPJ:</b> {{ this.location.managingOrganization.identifier ?? "n/a" | mask : '00.000.000/00-00' }}<br />
        <b>Contatos:</b> <br>
        <mat-icon>phone</mat-icon> {{ formatPhone(this.location.telecom[1].value)  }} <br />
        <mat-icon>mail</mat-icon> {{ this.location.telecom[0].value }} <br />
      </div>
      <page-map-view [latLong]="this.latLong" [address]="address"></page-map-view>
    </mat-tab>
    <mat-tab label="Horários de funcionamento">
      <mat-card  *ngFor="let horario of hours; let i = index" class="day-section">
       <h3 class="day-title">{{ getDayNames(horario.daysOfWeek) }} </h3>
        <div class="horarios">
          <div class="col-xs-12 ">
            <mat-form-field appearance="outline">
              <mat-label>Início do atendimento</mat-label>
              <input matInput readonly type="text" [(ngModel)]="horario.openingTime" [ngModelOptions]="{ standalone: true }"  />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Fim do atendimento</mat-label>
              <input matInput readonly type="text" [(ngModel)]="horario.closingTime" [ngModelOptions]="{ standalone: true }" />
            </mat-form-field>
          </div>        
        </div>
    </mat-card>    
    </mat-tab>
  </mat-tab-group>

